/**
 * Illumination Type.
 */
export enum IlluminationType {

  /** Laser. */
  Laser = 'Laser',

  /** Xenon. */
  Xenon = 'Xenon',
}
